import './App.css';
import logo from './assets/logo_pv.png';
import React, {useState} from 'react'; 
import api from './config/api';
import Alertas from './config/alertas';
import Swal from 'sweetalert2';

function App() {
  const [cpf, setcpf] = useState('');
  const [senha, setsenha] = useState('');

  function modal_carregando() {
    Swal.fire({
      
      text: "Carregando ...",
      timer: 2000,
      timerProgressBar: true,
      showCloseButton: false,
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEnterKey: false,
    })
  }

  function login() {
    if(cpf && senha){

      modal_carregando();

      let data = {
        "username": cpf,
        "password": senha
      }
      api.post("api/login_proview/", data)
      .then((res)=>{

        let data = res.data;
        if(data.autenticado){
          if( data.user.acesso_autorizado ){
              if(data.url){
                window.location.href = data.url;
              }else{
                Swal.close();
                Alertas.erro("Erro na recuperação da URL, contate o suporte")
              }
          }else{
            Swal.close();
            Alertas.toast_cuidado("Acesso bloqueado para este usuário");
          }
        }else{
          Alertas.toast_cuidado(data.msg);
        }
      }).catch((err)=>{
        Alertas.erro(err);
      })

    }else{
      Alertas.toast_cuidado("Preencher todos os campos");
    }
  }

  const bindBotaoEnter = (event) => {
    if (event.key === "Enter") login();
  }

  return (
    <div className="App">
      <div className='topo'></div>

      <div className='conteudo'>
        <div className='logo'>
          <img src={logo} alt="logo" />
        </div>

        <div className='card'>
          <div className='input-grupo'>
            <label>CPF</label>
            <input type="text" maxLength={11} value={cpf} onChange={(e)=>setcpf(e.target.value)} onKeyDownCapture={bindBotaoEnter}/>
          </div>

          <div className='input-grupo'>
            <label>SENHA</label>
            <input type="password" value={senha} onChange={(e)=>setsenha(e.target.value)} onKeyDownCapture={bindBotaoEnter}/>
          </div>

          <div className='input-grupo'>
            <button onClick={login}>ENTRAR</button>
          </div>
        </div>
      </div>
      <div className='rodape'>
        <p>Divisão de inovação e tecnologia | DPE-AM</p>
      </div>
    </div>
  );
}

export default App;
